module.exports = __webpack_public_path__ + "img/img_body_biz_speaking_max_logo.7d0f7751.png";